
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.436 2.883l-7.913 8.902c-.586.659-1.537.659-2.124 0L1.315 7.189c-.587-.66-.587-1.729 0-2.388.586-.66 1.536-.66 2.122 0l3.024 3.401L13.312.495c.587-.66 1.537-.66 2.123 0 .586.659.586 1.728 0 2.388z"}})])
          )
        }
      }
    